import { RegisterInfo } from "@/types/user";
import {
  getOS,
  getDisplayName,
  isSemHostname,
  isPromotingAds,
  getBuriedPointInfo,
} from "@/utils";
import { User, RegisterProfile } from "authing-js-sdk";
import { message } from "antd";
import { RegisterInfoSessionKey } from "@/constants/enum";
import { useNavigateWithSearch } from "@/hooks/useNavigateWithSearch";
import { getUserRegisterParams } from "../../utils";
import { useTranslation } from "react-i18next";
import { i18n } from "@/locales";
export const useGotoRegisterComplete = () => {
  const navigate = useNavigateWithSearch();

  const needComplete =
    window.__config__.extendsFieldsEnabled &&
    window.__config__.extendsFields.length > 0;
  const { t } = useTranslation();
  return [
    needComplete,
    async (registerInfo?: RegisterInfo) => {
      if (needComplete) {
        if (registerInfo) {
          sessionStorage.setItem(
            RegisterInfoSessionKey,
            JSON.stringify(registerInfo)
          );
        }
        const isExists = await window.__authing__.isUserExists({
          email: registerInfo?.email,
          phone: registerInfo?.phone,
        });
        if (isExists) {
          message.error(t("common.userExists"));
          setTimeout(() => {
            navigate("/login");
          }, 500);
        } else {
          navigate("/register-complete");
        }
      }
      return needComplete;
    },
  ] as const;
};

export const registerUser = async (
  registerInfo: RegisterInfo,
  {
    onSuccess,
    onFail,
    completeUserInfo,
    completeUdfsInfo,
  }: {
    onSuccess?: (user: User) => void;
    onFail?: (err: any) => void;
    /** 注册信息补全用户主字段 */
    completeUserInfo?: RegisterProfile;
    /** 注册信息补全用户自定义字段 */
    completeUdfsInfo?: Array<{
      key: string;
      value: any;
    }>;
  } = {}
) => {
  const authenticationClient = window.__authing__;
  const { phone, code, password, email } = registerInfo;
  const device = getOS();
  const browser = navigator.userAgent;
  let user: User;
  const customData = getUserRegisterParams() || {};
  if (completeUdfsInfo?.length) {
    completeUdfsInfo.forEach(({ key, value }) => {
      customData[key] = value;
    });
  }

  const isSem = isSemHostname();
  const promotingAds = isPromotingAds();
  const buriedPointInfo = getBuriedPointInfo();

  // 用户注册 注册消费埋点信息
  const context = {
    isSem,
    pa: promotingAds,
    ...buriedPointInfo,
  };

  try {
    let c = window.__config__;
    let registerToAuthing = c.userPoolId === c.rootUserPoolId;
    if (phone) {
      /** 有手机号，用手机号注册 */
      user = await authenticationClient.registerByPhoneCode(
        phone,
        code!,
        password,
        {
          browser,
          device,
          ...completeUserInfo,
        },
        {
          generateToken: true,
          customData,
          context,
          forceLogin: registerToAuthing, // 如果用户注册时向 Authing 用户池注册，那么就自带登录态
        }
      );
    } else if (email) {
      /** 有邮箱，用邮箱注册 */
      user = await authenticationClient.registerByEmail(
        email,
        password!,
        {
          browser,
          device,
          ...completeUserInfo,
        },
        {
          generateToken: true,
          customData,
          context,
          forceLogin: registerToAuthing, // 如果用户注册时向 Authing 用户池注册，那么就自带登录态
        }
      );
    }

    // 51cto 投放 临时解决方案

    if (window.__config__.id === "60cc6bc05603262842a5671a") {
      setTimeout(() => {
        window.location.href = "https://console.authing.cn/login";
      }, 500);
    } else {
      onSuccess?.(user!);
    }
    message.success(i18n.t("common.signUpSuccess") + getDisplayName(user!));
  } catch (e) {
    onFail?.(e);
  }

  return user!;
};
